var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { staticClass: "navbar-nav" },
    [
      _c(
        "b-nav-item-dropdown",
        {
          staticClass: "custom-select no-padding-vertical form-control",
          attrs: {
            text: _vm.label,
            right: _vm.align == "right",
            "no-caret": ""
          }
        },
        [
          _c("div", { staticClass: "b-dropdown-searchbox" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.search,
                  expression: "search"
                }
              ],
              staticClass: "form-control",
              attrs: { type: "text", placeholder: "Search" },
              domProps: { value: _vm.search },
              on: {
                submit: function(e) {
                  return e.preventDefault()
                },
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.search = $event.target.value
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("b-dropdown-divider"),
          _vm._v(" "),
          _vm._l(_vm.filteredOptions, function(option) {
            return _vm.filteredOptions.length > 0
              ? _c("b-dropdown-item", {
                  key: option.id,
                  class: [option.id == _vm.value ? "active" : ""],
                  domProps: { innerHTML: _vm._s(option.name) },
                  on: {
                    click: function($event) {
                      return _vm.updateValue(option)
                    }
                  }
                })
              : _c("b-dropdown-header", [_vm._v("-- None --")])
          })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ca382026", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ca382026","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/helpers/CustomSelectComponent.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-ca382026","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/helpers/CustomSelectComponent.vue
// module chunks = 0